const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;
const WEBSITE_URL = (process.env.REACT_APP_WEBSITE_URL || "http://localhost:3000").replace(/\/+$/, "");
const API_ORIGIN = (process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:5000/api")
  .replace(/\/+$/, "")
  .replace(/\/api$/, "");

export const resolvePartnerLogoUrl = (value) => {
  if (!value || typeof value !== "string") return "";
  if (ABSOLUTE_URL_PATTERN.test(value) || value.startsWith("data:") || value.startsWith("blob:")) {
    return value;
  }

  const path = value.startsWith("/") ? value : `/${value}`;
  return path.startsWith("/uploads/") ? `${API_ORIGIN}${path}` : `${WEBSITE_URL}${path}`;
};
